<template>
    <div>
        <h1 class="title is-3 between-center"><span>General Settings</span></h1>

        <div v-if="appIsHydrated" class="columns">
            <div class="column">
                <o-tabs type="is-boxed">
                    <o-tab-item label="Misc">
                        <div class="columns">
                            <div class="column is-two-thirds">
                                <o-field label="Service Billed Notification Subscribers">
                                    <multicomplete v-model="serviceBilledNotifees.value" type="user" :limit="9999" />
                                </o-field>

                                <p class="control">
                                    <button @click.prevent="handleSubmitServiceBilledNotifees" class="button is-success" v-submit="submitting">Update</button>
                                </p>

                                <br>

                                <o-field label="Default Terms and Conditions">
                                    <quill-editor
                                        v-model:content="terms.value"
                                        :content-type="'html'"
                                        :error="getError('value')" />
                                </o-field>

                                <p class="control">
                                    <button @click.prevent="handleSubmit" class="button is-success" v-submit="submitting">Update</button>
                                </p>

                                <br>

                                <o-field label="Default Terms and Conditions (Change Order)">
                                  <quill-editor
                                      v-model:content="termsCH.value"
                                      :content-type="'html'"
                                      :error="getError('value')" />
                                </o-field>

                                <p class="control">
                                    <button @click.prevent="handleSubmitCH" class="button is-success" v-submit="submitting">Update</button>
                                </p>
                            </div>
                        </div>
                    </o-tab-item>
                    <o-tab-item label="Task Categories">
                        <dictionary-table type="task-category" />
                    </o-tab-item>
                    <o-tab-item label="Lead Sources">
                        <dictionary-table type="lead-source" />
                    </o-tab-item>
                    <o-tab-item label="Timelog Misc Focus">
                        <dictionary-table type="timelog-misc" />
                    </o-tab-item>
                    <o-tab-item label="Timelog Activities">
                        <dictionary-table type="timelog-activity" />
                    </o-tab-item>
                </o-tabs >
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import HandlesForm from './../../mixins/HandlesForm'
    import DictionaryTable from './../../components/DictionaryTable'
    import Multicomplete from './../../components/Multicomplete'
    import {QuillEditor} from "@vueup/vue-quill";

    export default {
        mixins: [HandlesForm],

        components: {
          QuillEditor,
            DictionaryTable,
            Multicomplete
        },

        computed: {
            ...mapGetters([
                'defaultTermsAndConditions',
                'defaultTermsAndConditionsCH',
                'defaultServiceBilledNotifees',
                'userById',
                'appIsHydrated'
            ])
        },

        data() {
            return {
                terms: {
                    key: 'terms_and_conditions',
                    value: ''
                },
                termsCH: {
                    key: 'terms_and_conditions_ch',
                    value: ''
                },
                serviceBilledNotifees: {
                    key: 'service_billed_notifees',
                    value: []
                }
            }
        },

        mounted() {
            if (this.appIsHydrated) {
                this.fillSettings()
            }
        },

        watch: {
            appIsHydrated() {
                this.fillSettings()
            }
        },

        methods: {
            ...mapActions(['updateSetting']),

            fillSettings() {
                this.terms.value = this.defaultTermsAndConditions
                this.termsCH.value = this.defaultTermsAndConditionsCH
                this.serviceBilledNotifees.value = _.reduce(this.defaultServiceBilledNotifees, (res, userId) => {
                    let user = this.userById(userId)
                    if (user) res.push(user)
                    return res
                }, [])
            },

            handleSubmit() {
                let submit = this.wrapSubmit(this.updateSetting)

                submit(this.terms).then(res => {
                    this.successMessage('Default Terms and Conditions updated')
                    return res
                })
            },

            handleSubmitCH() {
                let submit = this.wrapSubmit(this.updateSetting)

                submit(this.termsCH).then(res => {
                    this.successMessage('Default Terms and Conditions (Change Order) updated')
                    return res
                })
            },

            handleSubmitServiceBilledNotifees() {
                let submit = this.wrapSubmit(this.updateSetting),
                    payload = {
                        key: this.serviceBilledNotifees.key,
                        value: _.map(this.serviceBilledNotifees.value, 'id')
                    }

                submit(payload).then(res => {
                    this.successMessage('Service Billed Notification Subscribers updated')
                    return res
                })
            }
        }
    }
</script>
